import { render, staticRenderFns } from "./ReferencesTreeNode.vue?vue&type=template&id=8f691e4e&scoped=true&"
import script from "./ReferencesTreeNode.vue?vue&type=script&lang=ts&"
export * from "./ReferencesTreeNode.vue?vue&type=script&lang=ts&"
import style0 from "./ReferencesTreeNode.vue?vue&type=style&index=0&id=8f691e4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f691e4e",
  null
  
)

export default component.exports